module.exports = __webpack_public_path__ + "img/3_2.8c6b19b7.jpg";